
import { View } from 'backbone';
import { Model } from 'backbone';
import listService  from 'ListService.js';
import Template from 'behaviors/properties/main/returnValueTarget.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
//=====================================================================
//
// An instance of this view represents a return-value-target.
//
// Casey Justus, April 25, 2016
//
//=====================================================================

class MainReturnValueTargetView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'click #returnField'             : 'launchModal'
        };

        if (this.model.get('fieldId')) {
            const id = this.model.get('fieldId');
            const obj = listService.getObject( listService.cleanId(id) );
            if (obj) {
                this.model.set('returnValueTarget', obj.model.get('name'), {silent: true});
            }
        }

        //this.listenTo(this.model, 'change', this.render);

        return this;
    }

    launchModal(ev){
        ev.preventDefault();

        var sfModel = new Model();
        var sfModal = new selectFieldModal({model: sfModel});
        sfModal.render().then((selectedField)=>{
            // used only for display in the UI
            this.model.set('returnValueTarget', selectedField.name, {silent: true});
            this.model.set('fieldId', selectedField.id, {silent: true});
            this.render();
        });
    }



    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainReturnValueTargetView;
